import { html, ref, repeat, ViewTemplate, when } from '@microsoft/fast-element';
import type { RFQSelector } from './rfq-selector';
import { RFQ_COLUMNS } from './column-config';
import { whiteCheckIcon, backArrowIcon } from '../../../../styles';
import { getFormattedDate, getFormattedNumber, getPriceValue} from '../../../../utils/formatting';
import { sync } from '@genesislcap/foundation-utils';

export const RFQSelectorTemplate: ViewTemplate<RFQSelector> = html`
  <div class="link-rfq-wrapper">
    <div class="link-rfq-header">
      <h3>Link RFQ to Contract</h3>
      <div class="button-wrapper">
        <zero-button appearance="card-primary" @click=${(x) => x.cancelRFQLinking()}>
          Return to Negotiations
        </zero-button>
        <zero-button appearance="card-primary" @click=${(x) => x.$emit('showAddRfq', true)}>
          Create RFQ
        </zero-button>
      </div>
    </div>
    <div class="vppa-info">
      <div>${(x) => x.selectedVppa?.TICKER}</div>
      <div>$${(x) => getPriceValue(x.selectedVppa?.FIXED_PRICE)}</div>
      <div>${(x) => getFormattedNumber(x.selectedVppa?.OFFERED_CAPACITY)}MW</div>
      <div>${(x) => getFormattedDate(x.selectedVppa?.TENOR_START_DATE)}</div>
    </div>

    <div class="rfq-header">Matching RFQs</div>
    <div class="rfq-grid">
      <zero-grid-pro
        class="grid-styles"
        only-template-col-defs
        sideBar=""
        rowSelection="multiple"
        suppressRowClickSelection="true"
        ${ref('rfqGrid')}
      >
        ${repeat(
          (x) => RFQ_COLUMNS(x),
          html`
            <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
          `
        )}
      </zero-grid-pro>
    </div>
    <div class="actions">
      <zero-button
        appearance="primary"
        :disabled=${(x) => x.disabledLinkBtn}
        class="with-icon"
        @click="${(x) => x.linkRFQs()}"
      >
        ${whiteCheckIcon('start')} Link Selected RFQ(s)
      </zero-button>
    </div>
  </div>
  ${when(
    (x) => x.isSummaryOpen,
    html<RFQSelector>`
      <summary-chat
        :vppaRfqData="${sync((x) => x.summaryData)}"
        :structuredChatEnums="${sync((x) => x.structuredChatEnums)}"
        :rfqCompany="${(x) => x.rfqCompanyName}"
      >
        <zero-button
          appearance="default"
          class="button-text"
          @click="${(x) => x.toggleSummary()}"
          slot="actions"
        >
          ${backArrowIcon('start')} Back to RFQ Selection
        </zero-button>
      </summary-chat>
    `
  )}
`;
